// extracted by mini-css-extract-plugin
module.exports = {"toggle":"QuickLinksModal_toggle__p_XP6","water":"QuickLinksModal_water___2qI0","rotate":"QuickLinksModal_rotate__NOyJf","pulsate":"QuickLinksModal_pulsate__xI9bq"};